<template>
  <b-container fluid>
    <page-title><h2><router-link :to="{ name: 'InvoiceTaxTypeList' }" class="nav-link">Stawki podatku VAT</router-link>/Nowa stawka</h2></page-title>

    <div class="col page-element">
      <alert-loading v-if="loading"></alert-loading>
      <div v-if="error" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ error }}</div>

      <InvoiceTaxTypeForm v-if="!loading" :handle-submit="create" :values="item" :errors="violations"></InvoiceTaxTypeForm>
    </div>
  </b-container>
</template>

<script>
  import InvoiceTaxTypeForm from './Form.vue';
  import { createNamespacedHelpers } from 'vuex';

  const { mapActions, mapGetters } = createNamespacedHelpers('invoicetaxtype/create');

  export default {
    components: {
      InvoiceTaxTypeForm
    },
    created(){
      this.$store.dispatch('invoicetaxtype/create/reset');
    },
    data: function() {
      return {
        item: {}
      }
    },
    computed: mapGetters([
      'error',
      'loading',
      'created',
      'violations'
    ]),
    methods: {
      create: function(item) {
        this.$store.dispatch('invoicetaxtype/create/create', item);
      }
    },
    watch: {
      created: function (created) {
        if (created) {
          this.$router.push({ name: 'InvoiceTaxTypeUpdate', params: { id: created['id']} });
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Create.vue?748b7b7a